import { Sprite, Texture } from 'pixi.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';

class NumOfBetsController {
	constructor(vc, conf) {
		this.config = conf;
		if (vc.auto_spin_bg.numOfBets) {
			this.vc = vc.auto_spin_bg.numOfBets;
			this.activeSprite = new Sprite(Texture.from(this.config.img.active));
			this.vc.addComponent(this.activeSprite, this.activeSprite);
			this.activeSprite.position.set(
				this.config.numbers[5].position.x + 15,
				20
			);
			this.init();
		} else {
			throw new Error(
				'SettigsItemController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	init() {
		for (var i = 0; i < this.config.numbers.length; i++) {
			this.vc[this.config.numbers[i].item].position.x =
				this.config.numbers[i].position.x;
			this.vc[this.config.numbers[i].item].bgText.text =
				this.config.numbers[i].text;
			this.vc[this.config.numbers[i].item].fgText.text =
				this.config.numbers[i].text;
			this.vc[this.config.numbers[i].item].setActive(
				GameConfigs.autospin.numOfBets === this.config.numbers[i].val
			);
			this.vc[this.config.numbers[i].item].handler = this.update.bind(this);
			this.disable(this.vc[this.config.numbers[i].item]);
		}
	}
	disable(item) {
		item.bgText.alpha = 1;
		item.fgText.alpha = 0;
		item.bg.alpha = 1;
		item.fg.alpha = 0;
		for (var i = 0; i < this.config.numbers.length; i++) {
			if (
				this.vc[this.config.numbers[i].item].bgText.text !==
				GameConfigs.autospin.numOfBets.toString()
			) {
				this.vc[this.config.numbers[i].item].fgText.alpha = 1;
				this.vc[this.config.numbers[i].item].fg.alpha = 1;
				this.vc[this.config.numbers[i].item].bgText.alpha = 0;
				this.vc[this.config.numbers[i].item].bg.alpha = 0;
			}
		}
	}
	update(e) {
		GameConfigs.autospin.numOfBets = this.vc[e].bgText.text;
		GameConfigs.autospin.leftBets = 0;
		this.disable(this.vc[e]);
	}
}

export default NumOfBetsController;
